export function isPromise(object: unknown): object is Promise<unknown> {
  return (
    (typeof object === 'object' || typeof object === 'function')

    && typeof (object as { then: unknown }).then === 'function'
  );
}
